/* istanbul ignore file */

import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { DotsSixVerticalIcon } from '@phosphor-icons/react'

import ShippingMethod from '@/configuration/components/ShippingMethod/ShippingMethod'

import * as Styles from './styles'

const SortableShippingMethod = props => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: props?.data?.id,
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <Styles.SortableShippingMethodContainer dragging={props.dragging} ref={setNodeRef} style={style}>
      <DotsSixVerticalIcon size={24} id="draggable-icon" data-testid="draggable-icon" {...attributes} {...listeners} />
      <ShippingMethod {...props} index={props.position} />
    </Styles.SortableShippingMethodContainer>
  )
}

export default SortableShippingMethod
